var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path, _path2, _path3, _path4, _path5, _path6, _g11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11156,
    height: 7173,
    viewBox: "0 0 11156 7173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10923.6 6831.4L10904.8 6236.84V5330.21H11095.8V7138.1H10875.2L10503.9 6201.87C10489.6 6164.2 10418.7 5976.78 10291.4 5639.59L10307.6 6231.46V7138.1H10121.9V5330.21H10342.5C10627.7 6054.8 10821.4 6555.2 10923.6 6831.4Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9586.47 5733.75C9586.47 5563.37 9497.69 5478.17 9320.13 5478.17C9144.36 5478.17 9056.48 5563.37 9056.48 5733.75V6734.55C9056.48 6906.73 9144.36 6992.82 9320.13 6992.82C9497.69 6992.82 9586.47 6906.73 9586.47 6734.55V5733.75ZM8865.47 5731.06C8865.47 5603.72 8904.03 5500.59 8981.15 5421.68C9058.27 5342.76 9171.27 5303.3 9320.13 5303.3C9470.79 5303.3 9584.68 5342.76 9661.8 5421.68C9738.92 5500.59 9777.48 5603.72 9777.48 5731.06V6739.93C9777.48 6867.27 9738.92 6970.4 9661.8 7049.32C9584.68 7126.44 9470.79 7165 9320.13 7165C9169.47 7165 9055.58 7126.44 8978.46 7049.32C8903.13 6970.4 8865.47 6867.27 8865.47 6739.93V5731.06Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_13_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8330.13 5330.21H8521.14V7138.1H8330.13V5330.21Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_13_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8121.35 5330.21V5499.7H7771.61V7138.1H7577.9V5499.7H7228.16V5330.21H8121.35Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_13_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6303.89 5698.78C6303.89 5444.1 6465.31 5316.76 6788.15 5316.76C6892.17 5316.76 6996.2 5331.1 7100.22 5359.8V5537.36C6994.41 5506.87 6888.59 5491.63 6782.77 5491.63C6676.95 5491.63 6602.52 5510.46 6559.47 5548.12C6516.43 5583.99 6494.9 5637.8 6494.9 5709.54V6761.45C6494.9 6831.4 6516.43 6885.21 6559.47 6922.87C6604.31 6958.74 6681.43 6976.68 6790.84 6976.68C6902.04 6976.68 7006.96 6962.33 7105.6 6933.63V7108.5C7015.93 7137.2 6910.11 7151.55 6788.15 7151.55C6465.31 7151.55 6303.89 7024.21 6303.89 6769.52V5698.78Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_13_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5782.45 5330.21H5973.46V6739.93C5973.46 6867.27 5934.9 6970.4 5857.78 7049.32C5782.45 7126.44 5669.46 7165 5518.8 7165C5368.14 7165 5254.25 7126.44 5177.13 7049.32C5101.8 6970.4 5064.14 6867.27 5064.14 6739.93V5330.21H5255.15V6734.55C5255.15 6906.73 5343.03 6992.82 5518.8 6992.82C5694.57 6992.82 5782.45 6906.73 5782.45 6734.55V5330.21Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_13_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4545.33 5739.13C4545.33 5577.72 4460.14 5497.01 4289.75 5497.01H4018.03V6968.61H4289.75C4460.14 6968.61 4545.33 6886.1 4545.33 6721.1V5739.13ZM3827.02 5330.21H4300.51C4443.99 5330.21 4552.5 5366.97 4626.04 5440.51C4699.57 5514.04 4736.34 5612.69 4736.34 5736.44V6726.48C4736.34 6853.82 4700.47 6954.26 4628.73 7027.79C4556.99 7101.33 4449.38 7138.1 4305.89 7138.1H3827.02V5330.21Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_13_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3291.56 5733.75C3291.56 5563.37 3202.78 5478.17 3025.22 5478.17C2849.45 5478.17 2761.57 5563.37 2761.57 5733.75V6734.55C2761.57 6906.73 2849.45 6992.82 3025.22 6992.82C3202.78 6992.82 3291.56 6906.73 3291.56 6734.55V5733.75ZM2570.55 5731.06C2570.55 5603.72 2609.11 5500.59 2686.24 5421.68C2763.36 5342.76 2876.35 5303.3 3025.22 5303.3C3175.87 5303.3 3289.76 5342.76 3366.89 5421.68C3444.01 5500.59 3482.57 5603.72 3482.57 5731.06V6739.93C3482.57 6867.27 3444.01 6970.4 3366.89 7049.32C3289.76 7126.44 3175.87 7165 3025.22 7165C2874.56 7165 2760.67 7126.44 2683.55 7049.32C2608.22 6970.4 2570.55 6867.27 2570.55 6739.93V5731.06Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_13_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1825.25 6411.71H1558.91V7138.1H1367.9V5330.21H1806.42C1949.9 5330.21 2058.41 5366.97 2131.95 5440.51C2205.48 5512.25 2242.25 5610.9 2242.25 5736.44V6002.78C2242.25 6196.49 2165.13 6322.03 2010.88 6379.43L2298.75 7138.1H2088.9L1825.25 6411.71ZM1558.91 6244.91H1798.35C1966.94 6244.91 2051.24 6163.31 2051.24 6000.09V5744.51C2051.24 5581.3 1966.94 5499.7 1798.35 5499.7H1558.91V6244.91Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_13_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M868.973 5747.2C868.973 5582.2 783.78 5499.7 613.394 5499.7H376.646V6347.14H613.394C783.78 6347.14 868.973 6265.54 868.973 6102.33V5747.2ZM185.634 5330.21H624.155C765.845 5330.21 873.457 5366.97 946.992 5440.51C1022.32 5514.04 1059.99 5612.69 1059.99 5736.44V6110.4C1059.99 6235.94 1023.22 6335.49 949.683 6409.02C876.147 6480.76 767.638 6516.63 624.155 6516.63H376.646V7138.1H185.634V5330.21Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9664.47 4610.96C9509.24 4610.96 9372.28 4579.01 9253.58 4515.09C9136.71 4451.18 9045.4 4363.52 8979.66 4252.13C8915.74 4140.73 8883.79 4012.9 8883.79 3868.63C8883.79 3724.37 8914.83 3596.54 8976.92 3485.14C9040.83 3373.75 9127.58 3287 9237.15 3224.92C9348.54 3161 9473.63 3129.04 9612.42 3129.04C9753.03 3129.04 9877.21 3160.09 9984.95 3222.18C10092.7 3284.27 10176.7 3371.92 10237 3485.14C10299.1 3596.54 10330.1 3727.11 10330.1 3876.85C10330.1 3887.81 10329.2 3900.59 10327.4 3915.2C10327.4 3929.81 10326.4 3943.51 10324.6 3956.29H9089.23V3767.28H10187.7L10080.8 3833.02C10082.7 3739.89 10063.5 3656.8 10023.3 3583.75C9983.13 3510.71 9927.43 3454.1 9856.21 3413.92C9786.82 3371.92 9705.55 3350.92 9612.42 3350.92C9521.11 3350.92 9439.85 3371.92 9368.63 3413.92C9297.41 3454.1 9241.71 3511.62 9201.54 3586.49C9161.36 3659.54 9141.27 3743.54 9141.27 3838.5V3882.33C9141.27 3979.12 9163.19 4065.86 9207.01 4142.56C9252.67 4217.43 9315.67 4275.87 9396.02 4317.87C9476.37 4359.87 9568.59 4380.87 9672.68 4380.87C9758.51 4380.87 9836.12 4366.26 9905.52 4337.04C9976.74 4307.82 10038.8 4264 10091.8 4205.56L10237 4375.39C10171.2 4452.09 10089 4510.53 9990.43 4550.7C9893.65 4590.88 9784.99 4610.96 9664.47 4610.96Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7605.25 4243.91L7610.73 3906.98L8446.19 3142.74H8763.94L8122.96 3772.76L7980.52 3893.29L7605.25 4243.91ZM7391.59 4594.53V2562.02H7654.56V4594.53H7391.59ZM8500.98 4594.53L7931.22 3887.81L8101.05 3676.89L8824.21 4594.53H8500.98Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6302.3 3129.04C6421 3129.04 6525.09 3151.87 6614.57 3197.52C6705.88 3243.18 6777.1 3312.57 6828.23 3405.7C6879.36 3498.84 6904.93 3616.62 6904.93 3759.06V4594.53H6641.96V3789.2C6641.96 3648.58 6607.26 3542.67 6537.87 3471.45C6470.3 3400.23 6374.43 3364.62 6250.25 3364.62C6157.12 3364.62 6075.85 3382.88 6006.46 3419.4C5937.07 3455.92 5883.2 3509.79 5844.85 3581.01C5808.32 3652.23 5790.06 3740.8 5790.06 3846.72V4594.53H5527.1V3142.74H5779.1V3534.45L5738.02 3430.36C5785.5 3335.4 5858.54 3261.44 5957.15 3208.48C6055.77 3155.52 6170.81 3129.04 6302.3 3129.04Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4284.15 4610.97C4159.97 4610.97 4050.41 4588.14 3955.45 4542.48C3862.31 4496.83 3789.27 4427.44 3736.31 4334.3C3685.18 4239.34 3659.61 4120.64 3659.61 3978.2V3142.74H3922.58V3948.07C3922.58 4090.51 3956.36 4197.34 4023.93 4268.56C4093.32 4339.78 4190.11 4375.39 4314.28 4375.39C4405.59 4375.39 4485.03 4357.13 4552.6 4320.61C4620.17 4282.26 4672.21 4227.47 4708.73 4156.25C4745.26 4083.21 4763.52 3995.55 4763.52 3893.29V3142.74H5026.48V4594.53H4777.21V4202.82L4818.3 4306.91C4770.82 4403.7 4699.6 4478.57 4604.64 4531.53C4509.68 4584.49 4402.85 4610.97 4284.15 4610.97Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11155.8 4591.53V2931.2H10868.4V3382.31L10896.5 3269.53C10850.7 3154.66 10773.7 3066.95 10665.4 3006.38C10557.1 2945.82 10423.8 2915.53 10265.5 2915.53V3206.87C10278 3204.79 10290.5 3203.74 10303 3203.74C10313.4 3203.74 10323.8 3203.74 10334.2 3203.74C10494.6 3203.74 10621.6 3251.78 10715.3 3347.85C10809.1 3443.92 10855.9 3582.8 10855.9 3764.5V4591.53H11155.8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 3859,
    height: 5028
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H3858.28V5027.99H0V0Z",
    fill: "#D9D9D9"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.247 733.248H2339.41V2147.37H733.247V733.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.247 2828.24H2496.53V4259.82H733.247V2828.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_13_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5027.99V-52.375H1748.44C2198.33 -52.375 2535.75 68.586 2760.69 310.508C2989.05 552.43 3103.22 871.767 3103.22 1268.52C3103.22 1534.63 3057.21 1766.88 2965.19 1965.25C2873.17 2158.79 2747.06 2308.78 2586.87 2415.23C2426.68 2521.67 2242.64 2574.9 2034.73 2574.9L2131.87 2277.33C2356.81 2277.33 2556.2 2330.56 2730.02 2437C2903.84 2538.61 3038.47 2691.02 3133.9 2894.23C3232.74 3097.45 3282.16 3346.63 3282.16 3641.77C3282.16 4077.23 3161.16 4418.34 2919.18 4665.1C2677.19 4907.02 2321.03 5027.99 1850.69 5027.99H0ZM823.096 4142.55H1789.34C2004.06 4142.55 2165.95 4094.17 2275.02 3997.4C2387.49 3895.79 2443.72 3736.12 2443.72 3518.39C2443.72 3305.5 2387.49 3148.25 2275.02 3046.64C2165.95 2940.2 2004.06 2886.98 1789.34 2886.98H761.747V2030.57H1646.19C1847.28 2030.57 2000.65 1982.19 2106.31 1885.42C2215.37 1783.81 2269.9 1631.4 2269.9 1428.19C2269.9 1229.81 2215.37 1082.24 2106.31 985.47C2000.65 883.863 1847.28 833.059 1646.19 833.059H823.096V4142.55Z",
    fill: "#EC7131"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_215",
    x: 10120.9,
    y: 5330.21,
    width: 981.894,
    height: 1815.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13_215",
    x: 8864.47,
    y: 5303.3,
    width: 920.017,
    height: 1869.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_13_215",
    x: 8329.13,
    y: 5330.21,
    width: 199.012,
    height: 1815.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_13_215",
    x: 7227.16,
    y: 5330.21,
    width: 901.185,
    height: 1815.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_13_215",
    x: 6302.89,
    y: 5316.76,
    width: 809.713,
    height: 1842.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_13_215",
    x: 5063.14,
    y: 5330.21,
    width: 917.326,
    height: 1842.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_13_215",
    x: 3826.02,
    y: 5330.21,
    width: 917.326,
    height: 1815.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_13_215",
    x: 2569.55,
    y: 5303.3,
    width: 920.016,
    height: 1869.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_13_215",
    x: 1366.9,
    y: 5330.21,
    width: 938.848,
    height: 1815.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_13_215",
    x: 184.634,
    y: 5330.21,
    width: 882.352,
    height: 1815.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0 0.791667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_13_215",
    x: 0,
    y: -152.375,
    width: 3640.16,
    height: 5280.36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 258
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_215",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.fa371ee3edc0e840f5ef7c3dc863e52c.svg";
export { ForwardRef as ReactComponent };